import React, { useEffect, useState } from "react";



import {  Link  } from "react-router-dom";
import createIcon from "./components/icons/add_circle_FILL0_wght200_GRAD0_opsz40.svg";
import notifIcon from "./components/icons/notifications_active_FILL0_wght200_GRAD0_opsz40.svg";
import msgIcon from "./components/icons/maps_ugc_FILL0_wght200_GRAD-25_opsz40.svg"
import closeIcon from "./components/icons/close_FILL0_wght200_GRAD-25_opsz40.svg"
import myLogo from "./components/img/Mock.png";
//import Dashboard from "./components/Dashboard";
import logoilogically from "./components/img/logoilogically.png";
import UserMenu from "./Navbar/UserMenu";
import './MenuBar.css'
import NavItem from "./components/UI/NavItem";
import CardBigLong from "./components/UI/CardBigLong"
import Logout from "./components/Logout";
import { AlignLeft ,Braces,Menu,Plus, X } from 'lucide-react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useSelector } from "react-redux";
import Loading from "./components/Loading/Loading";
import LinkedAccountBuilder from "./components/Create/RazorpayAccount/LinkedAccount/LinkedAccountBuilder";
import { Bar } from "recharts";

const MenuBar =()=>{
  const [isHovered, setIsHovered] = useState(false);
  const [loader , setLoader] =useState(false);
  const [hideMenu , setHideMenu] =useState(false);
  const dispatch = useDispatch();
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
 

  const history = useHistory();
 
   
   const localToken= localStorage.getItem("profile");
   const token = useSelector((state)=>state?.user?.user?.token);
  
const data = useSelector((state)=>state?.user?.user);
const [loginStatus,setLoginStatus] = useState(false)
const [openBankAccPopUp,setOpenBankAccPopUp] = useState(false)

useEffect(()=>{
  
  !data?setLoginStatus(true):setLoginStatus(false);
},[])
const courseNav=[{
    id:'1',
    title:"Payments",
    alt:"Simplified Linked Bank Account With hasslefree  Settlement",
    link:"/pages/?filter=Trending",
    icon:0,
    
  }  ,{ id:'5',
        title:"Auto Pay",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:5,
      }
      ,{ id:'6',
        title:"Payment Link",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:6,
      },{ id:'7',
        title:"Payments Analytics",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:7,
      },{ id:'7',
        title:" Subscription & EMI",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:7,
      },{ id:'8',
        title:"Installments",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:8,
      },{ id:'8',
        title:"Membership ",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:8,
      },{ id:'9',
        title:"Sharable Payments QR codes ",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:9,
      },{ id:'10',
        title:"Easy Merchant Account ",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:9,
      },{ id:'11',
        title:"Easier Settlement ",
        alt:"",
        link:"/pages/?payment=Paid",
        icon:9,
      }

]

  const courseNavOne=[
    {
    id:'1',
    title:"Branded Mobile Apps",
    alt:"Level Up Your Business With Your Own Customized Branded Android And iOS Mobile App",
    link:"/pages/?filter=Trending",
    icon:0,
    
  },
  { id:'2',
    title:"No-Code Web Builder",
    alt:"Create Fully Integrated Website With Few Clicks.We Help You To Host It On Your Custom Or Existing Domain",
    link:"/pages/?payment=Free",
    icon:1,
    
  },
   { id:'3',
    title:"No-Code Mobile App Builder",
    alt:"",
    link:"/pages/?payment=Free",
    icon:1,
    
  },
  { id:'4',
    title:"Web Themes ",
    alt:"Explore Multitudineous Themes , Choose And Customize It, So That Your Website Looks Unique For Your Business",
    link:"/pages/?payment=Paid",
    icon:4,
  },
  { id:'5',
    title:"App Themes",
    alt:"Choose From Multitude Of Themes To Brand Your Mobile App As Per Your Business Needs",
    link:"/pages/?payment=Paid",
    icon:2,
  },
  { id:'6',
    title:"Advanced Mock Test Builder",
    alt:"",
    link:"/pages/?payment=Paid",
    icon:2,
  },{ id:'7',
    title:"Integrated Course Builder",
    alt:"",
    link:"/pages/?payment=Paid",
    icon:2,
  },
  { id:'5',
    title:"Digital Product Store",
    alt:"Create And Sell Digital Products, Directly To Your Customers , Right Form Your Own Store. ",
    link:"/pages/?payment=Paid",
    icon:5,
  },
  { id:'6',
    title:"Landing Pages",
    alt:"Build high-converting landing pages without needing a designer.",
    link:"/pages/?payment=Paid",
    icon:6,
  }
,{ id:'3',
    title:"Contacts CRM  ",
    alt:"Move your audience off social media and own your relationship with them.",
    link:"/pages/?payment=Paid",
    icon:2,
  },{ id:'2',
    title:"Analytics & Performance",
    alt:"Use the right metrics, organized into reports you’ll actually use.",
    link:"/pages/?payment=Free",
    icon:1,
    
  }
]
  


  const courseNavTwo=[{
    id:'1',
    title:"Sell Online Courses",
    alt:"Create Unlimited Online Courses With Varied Contents And Sell Those On Your Own Website Or Branded  Mobile App",
    link:"/pages/?filter=Trending",
    icon:0,
    
  },{ id:'12',
    title:"Mock Tests & Test Series",
    alt:"Create Mock Tests, Test Series ,Scheduled Live Mocks , All India Free Live Mock As Lead Magnets.",
    link:"/pages/?payment=Free",
    icon:1,
    
  },{ id:'2',
    title:"One Course - Multiple Batches",
    alt:"Now You Can Create One Course And Add Multiple Teachers To Handle & Manage Multiple Batches.",
    link:"/pages/?payment=Free",
    icon:1,
    
  },
  { id:'6',
    title:"Membership Plans ",
    alt:"You Can Add Courses , Bundles or Categories Into Duration Based Membership Plans And Sell Subscriptions To Your Students",
    link:"/pages/?payment=Paid",
    icon:6,
  },
  { id:'7',
    title:"Manage Webinar ",
    alt:"The Best Way To Generate Leads Is Engage Your Students In Webinar And We Have Advanced Tools To Handle That.",
    link:"/pages/?payment=Paid",
    icon:7,
  }
  ,{ id:'9',
    title:"Digital Products",
    alt:"Sell Live Tests , Ebooks ,Newsletters , Notes , Question Banks And More  Right From Your Own Store",
    link:"/pages/?payment=Paid",
    icon:9,
  }
  ,{ id:'3',
    title:"Bundle Of Multiple Courses",
    alt:"You May Combine Multiple Courses Into One Bundle And Sell Those As One Product Which Ensures Reusability.",
    link:"/pages/?payment=Paid",
    icon:2,
  },{ id:'4',
    title:"Offline Classes & Coaching ",
    alt:"Now You Can Handle Your Coaching With Our Class Management Suit Which Includes - Admission , Time Table , Attendance,  Batches And More  ",
    link:"/pages/?payment=Paid",
    icon:4,
  },{ id:'5',
    title:"Teach At Home",
    alt:"You May Have A Personalized Set Up For Teaching Students At Their Home With Advanced Features",
    link:"/pages/?payment=Paid",
    icon:5,
  },
  { id:'8',
    title:"Appointment Booking For 1-1 Sessions",
    alt:" Creating 1-1 Consultation Sessions Or Private Group Sessions Is Now Easy. ",
    link:"/pages/?payment=Paid",
    icon:8,
  },
  { id:'10',
    title:"Podcasts",
    alt:"Sell Audio Or Video Podcasts With User-Friendly Interface Right From Your Own Store",
    link:"/pages/?payment=Paid",
    icon:10,
  },{ id:'11',
    title:"Community",
    alt:"Turn Your Followers To Community And Sell Among Them",
    link:"/pages/?payment=Paid",
    icon:11,
  }

]
  

  const courseNavThree=[{
    id:'1',
    title:"WhatsApp Broadcast",
    alt:"Get Automated WhatsApp Messages Sent To Users For Customizable  Events , User Activites ,Orders, Payments ,Reminders etc ",
    link:"/pages/?filter=Trending",
    icon:0,
    
  },{ id:'2',
    title:"E-mail Marketing Campaigns ",
    alt:"Choose From Beautifully Designed And Customizable E-Mail Templates And Set Automated Campaigns.",
    link:"/pages/?payment=Free",
    icon:1,
    
  },{ id:'3',
    title:"AI Driven Funnels & Automations",
    alt:"Set AI Driven Automated Funnels To Grab Leads.",
    link:"/pages/?payment=Paid",
    icon:2,
  },{ id:'4',
    title:"SEO",
    alt:"Manage Meta Tags And Keywords To Design SEO Friendly Website",
    link:"/pages/?payment=Paid",
    icon:4,
  },{ id:'5',
    title:"Lead Generation Tools",
    alt:"We Have Multitudinous Tools To Generate , Handle And Manage Leads Seamlessly",
    link:"/pages/?payment=Paid",
    icon:5,
  },{ id:'7',
    title:"Customer Segmentations ",
    alt:"Categorize Customers Based On Their Shared Behaviour And Set Automated Communications ",
    link:"/pages/?payment=Paid",
    icon:7,
  },{ id:'8',
    title:"Push Notifications ",
    alt:"Automated Push Notifications Sent To Your Own Branded Mobile App For Customizable  Events , User Activites , Payments ,Reminders etc ",
    link:"/pages/?payment=Paid",
    icon:8,
  },{ id:'10',
    title:"Discount Coupons ,Wallet Recharges & More",
    alt:"Lure Clients With Discount Coupons, Wallet Amounts ,Limited Time Offers And Manage Cart Abandonment etc ",
    link:"/pages/?payment=Paid",
    icon:10,
  },{ id:'11',
    title:"Newsletters",
    alt:"Let Your Users Download Ebook, Brochures etc With Subscription To E-mail",
    link:"/pages/?payment=Paid",
    icon:11,
  }
  ,{ id:'12',
    title:"Refer & Earn",
    alt:"Let Your Users Share Your Courses And Earn And Sell More Courses Using Refferal Codes",
    link:"/pages/?payment=Paid",
    icon:12,
  },{ id:'12',
    title:"Affiliate Marketing",
    alt:"Let Your Users Share Your Courses And Earn And Sell More Courses Using Refferal Codes",
    link:"/pages/?payment=Paid",
    icon:12,
  },{ id:'12',
    title:"Upsale",
    alt:"Let Your Users Share Your Courses And Earn And Sell More Courses Using Refferal Codes",
    link:"/pages/?payment=Paid",
    icon:12,
  }

]
  

  const courseNavFour=[
    {
    id:'1',
    title:"Create Lecture Presentation",
    alt:"Choose From PPT Themes To Create Course Thumbnails ,Lecture Slides,  Timed Quizzes As Slides And Teach Live Or Extract PDF  ",
    link:"/pages/?filter=Trending",
    icon:0,
    
  },
  { id:'2',
    title:" Design Course Certificates",
    alt:"Select From A Variety Of Designs To Create Course Certificates And Set Automation For Sending It To Users",
    link:"/pages/?payment=Free",
    icon:1,
    
  },
  
  { id:'3',
    title:"Create Brochure , Pamphlets",
    alt:"Create Brochure , Pamphlets And Auto Send Those To Users On Specific Events & Grab Leads.",
    link:"/pages/?payment=Paid",
    icon:2,
  },
  { id:'5',
    title:"Visiting Card , Greetings And More",
    alt:"Visiting Card , Greetings And More To Approach Your Leads Or Existing Students  Seamlessly",
    link:"/pages/?payment=Paid",
    icon:5,
  },{ id:'4',
    title:"E-Book Creator ",
    alt:" Convert Your Content, Course Or Test Series To Ebook And Sell It On Your Digital Store",
    link:"/pages/?payment=Paid",
    icon:4,
  },
  
  { id:'6',
    title:"Content Library",
    alt:"We Have Free Library Containing Quizzes , Videos And More. Just Select And Sell It As Yours",
    link:"/pages/?payment=Paid",
    icon:6,
  }]
  
  const courseNavFive=[{
    id:'1',
    title:"Class 1 to 12 Tuitions",
    alt:"Manage Your Offline Tuitions Batches , Give Your Students An Elevated Learning Experience With Your Own App",
    link:"/pages/?filter=Trending",
    icon:0,
    
  },{ id:'2',
    title:"BA/ BSC/ BCOM/ BTech ",
    alt:"Teach Your College Students With An UnConventional Approach And Lets Join The Change In Learning Technologies",
    link:"/pages/?payment=Free",
    icon:1,
    
  },{ id:'3',
    title:"UPSC /State PSC",
    alt:"If You Own A Coaching Institute,Manage It Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
    link:"/pages/?payment=Paid",
    icon:2,
  },{ id:'4',
    title:"JEE/ NEET",
    alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute" ,
      link:"/pages/?payment=Paid",
    icon:4,
  },{ id:'5',
    title:"Teaching Entrance Exams",
    alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
    link:"/pages/?payment=Paid",
    icon:5,
  },{ id:'6',
    title:"GATE / IES-ESE ",
    alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
    link:"/pages/?payment=Paid",
    icon:6,
  },{ id:'7',
    title:"CAT / GMAT",
    alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
    link:"/pages/?payment=Paid",
    icon:7,
  },{ id:'8',
    title:"Banking Exams",
    alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
    link:"/pages/?payment=Paid",
    icon:8,
  },{ id:'9',
    title:"CA / Law / CLAT ",
    alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
    link:"/pages/?payment=Paid",
    icon:9,
  }]

    const courseNavSix=[
      {
        id:'1',
        title:"AI Course Builder",
        alt:"Use A link or chapter pdf and let Our AI handle it for creating whole course with modules , tests or contents and Don't worry! Everything is customizable.   ",
        link:"/pages/?filter=Trending",
        icon:0,
        
      },
      
      { id:'2',
        title:"AI Test Series Builder",
        alt:"Our AI can create Mock Test series using pdfs or prompts which can be sold right away on your own app or website.",
        link:"/pages/?payment=Free",
        icon:1,
        
      }
      ,{ id:'12',
        title:"Create Android App With AI",
        alt:"Our AI can create customizable App Themes and unlimited features so that every app would look exclusive. ",
        link:"/pages/?payment=Paid",
        icon:2,
      }
      ,{ id:'3',
        title:"Create Website With AI ",
        alt:"Our AI can help you Create Your Own Institute's Website with many draft variations and customizable sections right through text chat. ",
        link:"/pages/?payment=Paid",
        icon:2,
      }
      ,{ id:'4',
        title:"AI Funnel & Segmentation  ",
        alt:"AI Automates and tracks or segments every step of funnel just for you." ,
          link:"/pages/?payment=Paid",
        icon:4,
      }

      ,{ id:'5',
        title:"AI Content Creator",
        alt:"You can create video lectures ,PPTs, Tests , Pdf , Ebooks With AI Prompts . ",
        link:"/pages/?payment=Paid",
        icon:5,
      }
      ,{ id:'6',
    title:"AI Video lectures ",
    alt:"You just need a prompt , link or pdf to create customizable Lecture PPTs &lecture videos with ai voiceover.",
    link:"/pages/?payment=Paid",
    icon:6,
  }
  ,{ id:'9',
    title:"Personalized AI Chat-Buddy for students",
    alt:"  Guide Your Students With A Personalized AI Chat Buddy who knows student's strengths and weaknesses and helps them persuasively achieve best results.",
    link:"/pages/?payment=Paid",
    icon:9,
  }
  ,{ id:'6',
    title:"AI Adaptive Learning   ",
    alt:"AI adapts course contents and provides more quizzes or assessments Based on student's  progress &  weaknesses ",
    link:"/pages/?payment=Paid",
    icon:6,
  }
  ,{ id:'6',
    title:"AI Batch Schedule Planner   ",
    alt:"",
    link:"/pages/?payment=Paid",
    icon:6,
  }
  ,{ id:'6',
    title:"AI Events For Lead Capture   ",
    alt:"",
    link:"/pages/?payment=Paid",
    icon:6,
  }
  ,
    
    
    ]

  const logOut =() =>{

    dispatch({type:"LOGOUT"});
    setLoginStatus(false);
    history.push('/login')
  }
 
return<>

{<Loading  Load={loader?.status}/>}
 <div id="hideMenuBar" className="menuOuter">
 
 <div className="TopLeftNavLogo" style={{float:'left',position: 'relative',top: '12px','paddingRight':'15px'}}>
  
<Plus onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  color="#958FDA" size={30} />

 </div>
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="TopLeftNavLogo" style={{float:'left',position: 'relative',top: '5px'}}> 
     <Link 
 to="">  <img src={myLogo}  style={{ "width":"140px",}}alt="User"/> 
            </Link> 
            
   </div>
          

              <div  className="TopLeftNavName" key="1">
                <Link 
//                  style={{ float:'left'
//     ,padding:'10px 25px',
//   textDecoration: 'none',
//   position: 'relative',
//   top: '2px',
//   fontSize: '26px',
//   border: '0px',
//   fontWeight: 'bold',
//   background: 'linear-gradient(270deg, #E02CD3 20.56%, #6243EB 56.63%, #0952FF 69.98%)',
//   backgroundClip: 'text',
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
// }} 
 to="">
               
                {/* <span onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  >ClassMock</span> */}
                </Link> 
            
                {/* <div  key="12">
                 
                  <div className="course-tab-outer" >
                  <Link    to="/">
                     <div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="course-tab-name">
               Products 
               </div></Link>

               <div className="course-tab-inner" >
               
               <NavItem setLoading={(e)=>{setLoader(e)}} first={true} icon={6} alt="Manage Apps" title="Manage Apps " 
               subNav={courseNavOne} key={courseNav?.id}  />
              
               <NavItem setLoading={(e)=>{setLoader(e)}} icon={1} alt="Build And Launch" title="Build And Launch " 
               subNav={courseNavTwo} key={courseNav?.id}  />
              
               <NavItem setLoading={(e)=>{setLoader(e)}} icon={2} alt="Scale" title="Marketing" 
               subNav={courseNavThree} key={courseNav?.id}  />
            
               <NavItem setLoading={(e)=>{setLoader(e)}} icon={3} alt="Earn And Measure" title="Earn And Measure " 
               subNav={courseNav} key={courseNav?.id}  />
               <NavItem setLoading={(e)=>{setLoader(e)}} icon={7} alt="AI Features" title="AI Features" 
               subNav={courseNavSix} key={courseNav?.id}  />
            
               <NavItem setLoading={(e)=>{setLoader(e)}} icon={4} alt="Creator Studio" title="Creator Studio" 
               subNav={courseNavFour} key={courseNav?.id}  />
                <NavItem setLoading={(e)=>{setLoader(e)}} icon={5} alt="Who Is It For" title="Who Is It For" 
               subNav={courseNavFive} key={courseNav?.id}  />
                </div>

              
             </div>
             </div> */}
             
             
              </div>
               <div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}  className={`TopRightNavSignUp  `} onClick={()=>{setHideMenu(false)}} >
            
            <Menu size={20} color="#222222" />
        </div>
             {!hideMenu? <div className="navbar-menu-outer" >
                <a href="javascript:void(0)"><div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{setOpenBankAccPopUp(true)}} className={`TopRightNavSignUp  `}style={{width:"100px"}} >
             
         Link Bank Acc.
         </div></a>
             {data==null?<>
             <Link to="/signup">
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="TopRightNavSignUp">
     SignUp
    </div> </Link>  <Link to="/login">
      <div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="TopRightNavLogin">
     Login
    </div> </Link></>:
    <> 
     <a href="javascript:void(0)"><div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}  className={`TopRightNavSignUp  `} onClick={logOut} >
            
            Logout
        </div> </a> 
        <a href="javascript:void(0)"> <div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}  className={`TopRightNavSignUp  `} onClick={()=>{setHideMenu(true)}} >
            
            <X size={16} color="#222222" />
        </div></a>  </>} 
    
    <style>{`
    
/* xs */
@media (max-width: 767px) { 
    .navbar-menu-outer{
    position:absolute;top:50px;right:0px; background:#fff; width:100%;height:100%;display:flex;justify-content:center;flex-wrap:wrap;
    }   }
    `}</style>
                {/* <div className="navbar-menu-start"> <img src={UserImg}  style={{ "width":"50px","height":"50px","borderRadius":"50%"}}alt="User"/> </div> */}
              {/* <div className="navbar-menu" >
           {/* <UserMenu/> */}
           
           {/* </div> */}
            </div>:""}
           
            <div className="navbar-menu-notif-outer" >
                {/* <div className="navbar-menu-notif-start">
                   <img src={notifIcon}style={{ "width":"40px","height":"40px","borderRadius":"50%","padding":"5px"}}  alt="Notification"/>
                    </div> */}
              <div className="navbar-menu" >
              <div className="notif-title"> 3 Notifications </div>
             
              <CardBigLong icon={notifIcon} arrow={closeIcon} alt="Notif" title="Title" details="All About Notif" />
              <CardBigLong icon={notifIcon} arrow={closeIcon} alt="Notif" title="Title" details="All About Notif" />
              <CardBigLong icon={notifIcon} arrow={closeIcon} alt="Notif" title="Title" details="All About Notif" />
             

            </div>
            </div> 
            <div className="navbar-menu-msg-outer" >
                {/* <div className="navbar-menu-msg-start">
                   <img src={msgIcon}style={{ "width":"40px","height":"40px","borderRadius":"50%","padding":"5px"}}  alt="Notification"/>
                    </div> */}
              <div className="navbar-menu" >
              <div className="notif-title"> 3 Messages </div>
             
              </div>
            </div> 
            </div>
  
 {openBankAccPopUp?<LinkedAccountBuilder closePopUp={()=>{setOpenBankAccPopUp(false)}} />:""}
</>
}
export  default MenuBar;